

function boldString(str, substr) {
    var strRegExp = new RegExp(substr, 'g');
    return str.replace(strRegExp, '<b><i>'+substr+'</i></b>');
  }
  
  
  
  const newWorkBtn = document.querySelector("#worksheets-btn");
  newWorkBtn.addEventListener("click", (e) => {
    checkID();
    showModal('patientId');
    
    console.log(e);
  });
  const dispRegion = document.getElementById('confirmRegion');
  const sonoLine = document.getElementById('sono')
  function displayIdRegions () {
      dispRegion.style.display = 'block';
      
  }
  
  
  function showPatID() {
    document.getElementById("patientId").style.display = "block";
  }
  
  
  const togMenuBtn = document.querySelector("#togMenu");
  
  togMenuBtn.addEventListener("click", (e) => {
    myFunction();
    console.log(e);
  });
  function myFunction() {
    var x = document.getElementById("navDemo");
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else {
      x.className = x.className.replace(" w3-show", "");
    }
  }
  function printReport() {
    document.getElementById("nonPrintable").className += "noPrint";
    window.print();
  }
  const printReportBtn = document.querySelector("#printReport");
  printReportBtn.addEventListener("click", (e) => {
    printReport();
    console.log(e);
  });
  
  function showReportModal() {
    document.getElementById("reportModal").style.display = "block";
  }
  
  function showModal(id) {
    document.getElementById(id).style.display = "block";
  }
  
  window.onclick = function (event) {
    if (
      event.target.id == "id01" ||
      event.target.id == "id02" ||
      event.target.id == "id03" ||
      event.target.id == "id04" ||
      event.target.id == "id05" ||
      event.target.id == "reportModal" ||
      event.target.id == "patientId" ||
      event.target.id == 'rightNodule' 
    ) {
      document.getElementById(event.target.id).style.display = "none";
    }
  };
  
    
    function checkID() {
     if (identifier.patient === '' || identifier.sono === '' ) {
      showPatID();
     }
    }

  
  
  
  function showDiv(id) {
    var x = document.getElementById(id);
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else { 
      x.className = x.className.replace(" w3-show", "");
    }
  }    
  
  const history = {
      
      side :"",
      region: '',
      text: '',
      symptoms: "",
      
      reportLine :function () {
        history.reportLine = clinReport();
      }
    };
    
    
    const identifier =  {
      patient: "",
      sono : "",
    }
    
    function getPatID() {
      
    document.querySelector("#patIdLine").innerHTML = "Accession No.  -  " + identifier.patient
      document.querySelector("#echoIdLine").innerHTML = 'Sonographer  -  ' + identifier.sono;
      document.getElementById("hisTitle").innerHTML =  'ECHOCARDIOGRAM - Preliminary Sonographer Report ';
      document.getElementById("patientId").style.display = "none";
    }
    
    const pDSubBtn = document.querySelector("#patDetSub");
    pDSubBtn.addEventListener("click", (e) => {
      
      identifier.patient = document.getElementById('patDet').value;
      identifier.sono = document.getElementById('sono').value;
      getPatID();
      
      
      
      console.log(e);
    });
  
    
    
    const hisSymBtn = document.querySelectorAll(".hisSym");
    hisSymBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        history.symptoms = e.target.textContent;
        console.log(e);
      });
    });
    const hisSideBtn = document.querySelectorAll(".hisSid");
    hisSideBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        history.side = e.target.id;
        console.log(e);
      });
    }); 
    const hisRegionBtn = document.querySelectorAll(".hisRegion");
    hisRegionBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        history.region = e.target.id;
        console.log(e);
      });
    }); 
    const hisText = document.querySelector("#hisText");
        hisText.addEventListener("focusout", (e) => {
              history.text = e.target.value;
              console.log(e);
            });
  
    function clinReport() { 
        history.reportLine =
           `${history.symptoms} ${history.text}`
        
    }

    
       
    
    function addClin() {
     
      clinReport();
      
      document.getElementById("hisRpt").innerHTML = history.reportLine + '. ';
      }

//-------------------------achilles.js--------------------------------------

      const leftVent = {
        id : 'leftVentRpt',
        name : 'LEFT VENTRICLE',
        finding: 'Sinus rhythm. Systolic function normal. No RWMA.  LV size is normal. LV geometry is normal. Filling parameters suggest normal diastolic function. ',
        rhythm : 'Sinus rhythm. ',
        systolic : ' LV systolic function is normal. ',
        RWMA : ' No regional wall motion abnormality. ',
        size :' LV size is normal. ',
        geometry : ' LV wall thickness is normal. ',
        diastolic : ' Filling parameters suggest normal diastolic function. ',

        reportLine : function () {
          leftVent.reportLine = leftVentReport(leftVent);
        }
      };

      function leftVentReport(element) {
        element.reportLine = element.rhythm + element.systolic + " EF - " + measure.LVEF + "%.  " + element.RWMA + "  "  + element.size + element.geometry + element.diastolic;
      }
      const leftVentText = document.querySelectorAll('.leftVentText')       
      leftVentText.forEach((element) => {
         element.addEventListener('focusout', function (e) {
         let property = this.dataset.prop;
         leftVent[property] = e.target.value;
             console.log(e);
         });
      });
      const leftVentBtn = document.querySelectorAll(".leftVentBtn")
      leftVentBtn.forEach((button) => {
       button.addEventListener("click", function  (e)  {
       property = this.dataset.prop;
         leftVent[property] = e.target.id;
         console.log(e);
       })
      })

      const bsa = {
          id : 'bsaRpt',
          name :'BSA',
          height : '',
          weight : '',
          value : ''

      }
      
      
      
      const atria = {
        id :'atriaRpt',
        name : 'ATRIA -  ',
        finding: 'Left and right atrium are normal in size. Interatrial septum appears intact.',
        left: ' Left atrium is normal in size. ' ,
        leftText : '',
        right : ' Right atrium is normal in size. ',
        rightText : '',
        septum : ' Interatrial septum appears intact. ',
        reportLine : function () {
          atria.reportLine = atriaReport();
        }
      };
      function atriaReport(element) {
        element.reportLine = element.left + element.leftText + element.right
         + element.rightText +  element.septum;
      }
      const atriaText = document.querySelectorAll('.atriaText')       
      atriaText.forEach((element) => {
         element.addEventListener('focusout', function (e) {
         let property = this.dataset.prop;
         atria[property] = e.target.value;
             console.log(e);
         });
      });
      const atriaBtn = document.querySelectorAll(".atriaBtn")
      atriaBtn.forEach((button) => {
       button.addEventListener("click", function  (e)  {
       property = this.dataset.prop;
         atria[property] = e.target.id;
         console.log(e);
       })
      })
      
      const rightVent = {
        id :'rightVentRpt',
        name : 'RIGHT VENTRICLE -  ',
        finding: ' Normal RV size and function. ',
        
        reportLine : function () {
          rightVent.reportLine = rightVentReport();
        }
      };
      function rightVentReport(element) {
        element.reportLine = element.finding;
      }
      const rightVentText = document.querySelectorAll('.rightVentText')       
      rightVentText.forEach((element) => {
         element.addEventListener('focusout', function (e) {
         let property = this.dataset.prop;
         rightVent[property] = e.target.value;
             console.log(e);
         });
      });
      const rightVentBtn = document.querySelectorAll(".rightVentBtn")
      rightVentBtn.forEach((button) => {
       button.addEventListener("click", function  (e)  {
       property = this.dataset.prop;
         rightVent[property] = e.target.id;
         console.log(e);
       })
      })
      
      const aoValve = {
        id :'aoValveRpt',
        name : 'AORTIC VALVE  -  ',
        finding: 'trileaflet, thin and mobile. No AR. Aortic root normal. Ascending aorta is not dilated.',
        LVOT: '',
        cusp : ' Trileaflet, ',
        leaflets : ' thin and mobile. ',
        leafText : '',
        stenosis : '',
        regurg : ' No aortic regurgitation. ',
        aoRoot : ' Aortic root is normal diameter. ',
        ascAo : ' Ascending aorta is normal diameter. ',
        reportLine : function () {
          aoValve.reportLine = aoValveReport();
        }
      };

      function ascAoRep(element) {
        if (element.aoRoot === ' Aortic root is normal diameter. ' && element.ascAo === ' Ascending aorta is normal diameter. ') {
          element.aoRoot = ' Aortic root and ascending aorta are normal diameter.'
          element.ascAo = ''
        }
        if (element.aoRoot === ' Aortic root is mildly dilated. ' && element.ascAo === ' Ascending aorta is mildly dilated. ') {
          element.aoRoot = ' Aortic root and ascending aorta are mildly dilated.'
          element.ascAo = ''
        }
      }
      function aoValveReport(element) {
        ascAoRep(element);
        element.reportLine = element.cusp + element.leaflets +  element.leafText + element.stenosis + element.regurg
         + element.aoRoot + element.ascAo;
      }
      const aoValveText = document.querySelectorAll('.aoValveText')       
      aoValveText.forEach((element) => {
         element.addEventListener('focusout', function (e) {
         let property = this.dataset.prop;
         aoValve[property] = e.target.value;
             console.log(e);
         });
      });
      const aoValveBtn = document.querySelectorAll(".aoValveBtn")
      aoValveBtn.forEach((button) => {
       button.addEventListener("click", function  (e)  {
       property = this.dataset.prop;
         aoValve[property] = e.target.id;
         console.log(e);
       })
      })

      const mitralValve = {
        id :'mitralValveRpt',
        name : 'MITRAL VALVE  -  ',
        finding: 'Leaflets thin and mobile. No MR.',
        leaflets: ' Leaflets are thin and mobile. ',
        leafText : '',
        prolapse : '',
        annulus : '',
        stenosis : '',
        regurg : ' No mitral regurgitation. ',
        eccentric : '',
        reportLine : function () {
          mitralValve.reportLine = mitralValveReport();
        },
      };
      function mitralValveReport(element) {
        element.reportLine = element.leaflets + element.leafText + element.prolapse +  element.annulus + element.stenosis + element.regurg + element.eccentric;
      }
      const mitralValveText = document.querySelectorAll('.mitralValveText')       
      mitralValveText.forEach((element) => {
         element.addEventListener('focusout', function (e) {
         let property = this.dataset.prop;
         mitralValve[property] = e.target.value;
             console.log(e);
         });
      });
      const mitralValveBtn = document.querySelectorAll(".mitralValveBtn")
      mitralValveBtn.forEach((button) => {
       button.addEventListener("click", function  (e)  {
       property = this.dataset.prop;
         mitralValve[property] = e.target.id;
         console.log(e);
       })
      })

      const tricuspValve = {
        id :'tricuspValveRpt',
        name : 'TRICUSPID AND PULMONARY VALVES -  ',
        finding: '. No TR. RVSP could not be assessed. PV structurally normal. No PR',
        tricusp: ' TV structurally normal. ' ,
        triText: '',
        pulm : ' PV structurally normal. ',
        pulmText: '',
        TR : ' No tricuspid regurgitation. ',
        PR : ' No pulmonary regurgitation. ',
        pressure : ' RVSP could not be assessed due to insufficient tricuspid regurgitation. ',
        
        reportLine : function () {
          tricuspValve.reportLine = tricuspValveReport();
        }
      };
      function tricuspValveReport(element) {
        element.reportLine = element.tricusp +  element.triText + element.TR + element.pressure
         + element.pulm + element.pulmText + element.PR;
         if (tricuspValve.pressure !== ' RVSP could not be assessed due to insufficient tricuspid regurgitation. ' ) {
          element.reportLine = element.tricusp +  element.triText + element.TR + element.pressure + measure.RVSP + 'mmHG.'
          + element.pulm + element.pulmText + element.PR;
         }
      }
      const tricuspValveText = document.querySelectorAll('.tricuspValveText')       
      tricuspValveText.forEach((element) => {
         element.addEventListener('focusout', function (e) {
         let property = this.dataset.prop;
         tricuspValve[property] = e.target.value;
             console.log(e);
         });
      });
      const tricuspValveBtn = document.querySelectorAll(".tricuspValveBtn")
      tricuspValveBtn.forEach((button) => {
       button.addEventListener("click", function  (e)  {
       property = this.dataset.prop;
         tricuspValve[property] = e.target.id;
         console.log(e);
       })
      })
      
      const pericardium = {
        id :'pericardiumRpt',
        name : 'PERICARDIUM  -  ',
        finding: ' No pericardial effusion. ',
        
        reportLine : function () {
          pericardium.reportLine = pericardiumReport();
        }
      };
      function pericardiumReport(element) {
        element.reportLine = element.finding;
      }
      const pericardiumText = document.querySelectorAll('.pericardiumText')       
      pericardiumText.forEach((element) => {
         element.addEventListener('focusout', function (e) {
         let property = this.dataset.prop;
         pericardium[property] = e.target.value;
             console.log(e);
         });
      });
      const pericardiumBtn = document.querySelectorAll(".pericardiumBtn")
      pericardiumBtn.forEach((button) => {
       button.addEventListener("click", function  (e)  {
       property = this.dataset.prop;
         pericardium[property] = e.target.id;
         console.log(e);
       })
      })        
      

const objects = [ leftVent, aoValve, mitralValve, atria, tricuspValve, rightVent, 
  pericardium]
      function addComments() {
        leftVentReport(leftVent);
        rightVentReport(rightVent);
        aoValveReport(aoValve);
        mitralValveReport(mitralValve);
        tricuspValveReport(tricuspValve);
        atriaReport(atria);
        pericardiumReport(pericardium);
          objects.forEach(function(element) {
            document.getElementById(element.id).innerHTML = element.reportLine;
          });
        };
const extras = [ ]      
      
  function addExtras() {
    
      extras.forEach(function(element) {
        document.getElementById(element.id).innerHTML = element.name + element.finding;
      });
    };
      
      const normalRepBtn = document.querySelector("#normalRep");
        normalRepBtn.addEventListener("click", (e) => {
          
        
          addClin();
          
          addComments();
        createReport();
        
          console.log(e);
        });
      
        const echoValDecBtns = document.querySelectorAll('.echo-val-dec')       
        echoValDecBtns.forEach((button) => {
            button.addEventListener('focusout', function (e) {
            var property = this.id
            measure[property] = e.target.value / 10
            
             console.log(e);
            });
        });
        const echoValBtns = document.querySelectorAll('.echo-val')       
        echoValBtns.forEach((button) => {
            button.addEventListener('focusout', function (e) {
            var property = this.id
            measure[property] = e.target.value;
            displayRWT();
            displayLVMass();
            displayRVSP();
            displayAAI();
            displayLVGeo();
            displayDiast();
            displayAoRoot();
            displayAscAo();
            displayAtrialSize();
                console.log(e);
            });
          });
            const echoValBSABtns = document.querySelectorAll('.echo-val-bsa')       
            echoValBSABtns.forEach((button) => {
                button.addEventListener('focusout', function (e) {
                var property = this.id
                bsa[property] = e.target.value;
                calcBSA();
                measure.BSA = bsa.value;
                    console.log(e);
                });
        });       
        const echoValddBtns = document.querySelectorAll('.echo-val-dd')       
        echoValddBtns.forEach((button) => {
            button.addEventListener('focusout', function (e) {
            var property = this.id
            var tempPropery = e.target.value / 100
            measure[property] = tempPropery.toFixed(1)
            displayEARatio();
            displayRVSP();
        
                console.log(e);
            });
        });       
        const measure = {
           LVDD: 0,
           
           LVDS : 0,
           IVS : 0,
           PW : 0,
           
          BSA : '',
           LVVolInd : 0,
           LVMass : 0,
           LVEF : 0,
           
           HR : '',
           RWT : 0,
           LVMI : 0,
          
           LVOT : 0,
           aoTSD : 0,
           aoSTJ : 0,
           aoAsc : 0,
           aoAscIndex : 0,

           LAArea : 0,
           RAArea : 0,
           LAVolIndex : 0,

           EVel : 0,
           AVel : 0,
           EARatio : 0,
           
           MVDecel : 0,
           ADur : 0,
           EPrime : 0,
           EOnEPrime : 0,
           MVPHT : '',
           MVMeanGrad : '',
           MVA : '',

           AVVel : 0,
           LVOTVel : 0,
           AVPeak : '',
           AVMean : '',
           AVA : '',
           AVPHT : '',

          TRVel : '',
          RAPress : '',
        
          RVSP : '',
          SPrime : 0,
          TAPSE : 0,

          PVVel : 0,
          PVPeak : ''
          
        }
function createMeasureReport() {
  checkRvsp();
  document.getElementById('LVDDrpt').innerHTML = measure.LVDD;
  document.getElementById('LVDSrpt').innerHTML = measure.LVDS;
  document.getElementById('LVMIrpt').innerHTML = measure.LVMI;
  document.getElementById('EVelrpt').innerHTML = measure.EVel;
  document.getElementById('EPrimerpt').innerHTML = measure.EPrime;
  showModal('measureModal');
}

function createReport() {
  Object.entries(measure).forEach(([key, value]) => {
    document.getElementById(key +'rpt').innerHTML = `${value}`;
    showModal('reportModal');
  })
}

function checkRvsp() {
  if ( measure.RVSP === 3) 
    measure.RVSP = '';
  
}


const measureRepBtn = document.querySelector('#measureRep'); 
measureRepBtn.addEventListener('click', (e) => {
  createReport();
  console.log(e);
})

/*var copyBtn = document.querySelector('#copy_btn');
copyBtn.addEventListener('click', (e) => {
  var copyText = document.querySelector("table");
  copyText.select();
  copyText.setSelectionRange(0, 99999); 
  navigator.clipboard.writeText(copyText.value);
  alert("Copied");
  console.log(e);
});*/


       function calculateRWT() {
           if (measure.PW === 0) {
               return;
           } else {
               var relativeWT = ( (2 * (measure.PW /10) ) / (measure.LVDD/10) )
           measure.RWT = relativeWT.toFixed(2)
       }};
       function displayRWT() {
           calculateRWT();
           document.getElementById('RWT').innerHTML = 'RWT -  ' + measure.RWT;
       }
               
       function calculateLVMass() {
           
           var sumLV = (measure.IVS/10)+ (measure.LVDD/10) + (measure.PW/10)
           var leftVDim = measure.LVDD/10
           var leftVMass = 0.8 * 1.04 * [Math.pow(sumLV, 3) - Math.pow(leftVDim,3)] + 0.6;
           measure.LVMass = leftVMass.toFixed(0);
           var leftVMI = measure.LVMass / bsa.value;
           measure.LVMI = leftVMI.toFixed(0);
       }
       function calcBSA() {
           if (bsa.weight > 0) {
               var bsCalc = [(bsa.height * bsa.weight) / 3600]
           var bsPow = Math.pow(bsCalc, 0.5)
           bsa.value = bsPow.toFixed(1)
           document.getElementById('bsa').innerHTML = 'BSA -  ' + bsa.value + 'm2';
           document.getElementById('bsarpt').innerHTML = bsa.value;
           document.getElementById('heightrpt').innerHTML = bsa.height;
           document.getElementById('weightrpt').innerHTML = bsa.weight;
       }}
       
       function calcEaRatio() {
        if ((measure.EVel || measure.AVel) === 0) {
          return;
         } else { 
            var tempRatio = measure.EVel / measure.AVel;
            measure.EARatio = tempRatio.toFixed(1);
            }
          }
        
       function displayEARatio() {
        if ((measure.EVel && measure.AVel) !== 0) {
          calcEaRatio();
          document.getElementById('EARatio').innerHTML = 'E/A Ratio  -  ' + measure.EARatio;
        }
       }
       function calcAAI() {
        if (measure.aoAsc !== 0) {
         var aoAsc = measure.aoAsc / 10;
         var index = aoAsc / measure.BSA;
         measure.aoAscIndex = (+index).toFixed(1);
        }
       }
       function displayAAI() {
        calcAAI();
        document.getElementById('aoAscIndex').innerHTML = 'Asc Ao Index  -  ' + measure.aoAscIndex;
       }    
       function calcRVSP() {
        if ((measure.TRVel || measure.RAPress) === '')
        return; 
        else { 
         var vel = Number(measure.TRVel)
         var press = Number(measure.RAPress)
         var pow = (Math.pow(vel, 2) * 4);
         var rvsp = pow + press;
          measure.RVSP = (+rvsp).toFixed(0);
        }}

       function displayRVSP() {
       
           calcRVSP();
           document.getElementById('RVSP').innerHTML = 'RVSP -  ' + measure.RVSP;
       }
       function displayLVMass() {
           if (measure.PWd === 0 ) {
               return;
           } else {
           calculateLVMass();
           
           document.getElementById('LVMass').innerHTML = `LVMass -  ${measure.LVMass}g`;
           document.getElementById('LVMI').innerHTML = `LV Mass Index  -  ${measure.LVMI}g/m2`;
       }}          
        function displayLVGeo() {
          var rwt = Number(measure.RWT)
          var pwt = Number(measure.PW)
          if (rwt > 0.42 && rwt < 0.5 && pwt < 11) {
            leftVent.geometry = ' LV wall thickness is upper normal. '
          }
          if (rwt > 0.42 && pwt === 11) {
            leftVent.geometry = ' LV relative wall thickness is mildly increased. '
          }
          if (pwt > 11) {
            leftVent.geometry = ' LV wall thickness is mildly increased. '
          }
          if (pwt > 13) {
            leftVent.geometry = ' LV wall thickness is increased. '
          }
        } 
        function displayDiast() {
          if (measure.EARatio === 0) {
            return;
          }
          var mdt = Number(measure.MVDecel)
          var eprime = Number(measure.EPrime)
          var earatio = Number(measure.EARatio)
          if (mdt > 240 && earatio < 0.9 && eprime < 8) {
            leftVent.diastolic = ' Filling parameters suggest impaired LV relaxation. '
          }
        }
        function displayAoRoot() {
          if (measure.aoRoot === 0) {
            return;
          }
          var aoroot = Number(measure.aoTSD)
          if (aoroot > 37) {
            aoValve.aoRoot = ' Aortic root is mildly dilated. '
          }
          if (aoroot > 41) {
            aoValve.aoRoot = ' Aortic root is dilated. '
          }
        }
        function displayAscAo() {
          if (measure.aoAscIndex === 0) {
            return;
          }
          var aorta = Number(measure.aoAsc)
          var index = Number(measure.aoAscIndex)
          if (aorta > 35 && index > 1.9) {
            aoValve.ascAo = ' The ascending aorta is mildly dilated. '
          }
          if (aorta > 38) {
            aoValve.ascAo = ' The ascending aorta is mildly dilated. '
          }
          if (aorta > 40) {
            aoValve.ascAo = ' The ascending aorta is dilated. '
          }
        }
        function displayAtrialSize() {
          if (measure.RAArea === 0) {
            return;
          }
          var rarea = Number(measure.RAArea)
          var larea = Number(measure.LAArea)
          var index = Number(measure.LAVolIndex)
          if (larea > 20 || index > 34) {
            atria.left = ' Left atrium is mildly dilated. '
          }
          if (larea > 30) {
            atria.left = ' Left atrium is moderately dilated. '
          }
          if (rarea > 20) {
            atria.right = ' Right atrium is mildly dilated. '
          }
          if (rarea > 30) { 
            atria.right = ' Right atrium is moderately dilated. '
          }
          if (index > 34 && rarea >= larea) {
            atria.left = ' Left and right atrium are mildly dilated. '
            atria.right = ' '
          }
        }
        
    
  function populate() {
    checkID();
    addClin();
    
  };
  /*
  const buttons = Array.from(document.getElementsByTagName('button'));
  buttons.forEach((element) =>  {
    element.addEventListener('click',(e) => {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
    });
      console.log(e);
    })
  });
  */
 
  
  
  const reOpenWSBtn = document.querySelector("#savRep");
  reOpenWSBtn.addEventListener("click", () => {
    showModal('reportModal');
  });

  const panels = Array.from(document.getElementsByClassName('w3-panel'));
  panels.forEach((element) =>  {
    element.addEventListener('click',(e) => {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
    });
      console.log(e);
    })
  });

  

  function hideElements(array) {
    array.forEach(function (element) {
      element.style.display = 'none';
    })
  }   function displayElements(array) {
   array.forEach(function (element) {
     element.style.display = 'inline';
   })
 }  
  function hideDiv(id) {
  document.getElementById(id).style.display = 'none';
  }
  function displayDiv(id) {
    document.getElementById(id).style.display = 'inline'
  }
  